import React from 'react';
import { Zap, Sparkles, Crown } from 'lucide-react';

const TIERS = [
  {
    id: 'draft',
    icon: Zap,
    label: 'Draft',
    cost: 0.003,
    speed: '~5 sec'
  },
  {
    id: 'standard',
    icon: Sparkles,
    label: 'Standard',
    cost: 0.025,
    speed: '~15 sec'
  },
  {
    id: 'premium',
    icon: Crown,
    label: 'Premium',
    cost: 0.05,
    speed: '~30 sec'
  }
];

function QualityTierPicker({ value, onChange, variantCount = 1, onVariantCountChange }) {
  const selectedTier = TIERS.find(t => t.id === value);
  const variantCost = selectedTier ? (selectedTier.cost * variantCount).toFixed(3) : '0.000';

  return (
    <div className="space-y-6">
      {/* Variant Count Slider */}
      <div>
        <div className="flex items-center justify-between mb-3">
          <label className="text-white block text-sm font-medium">Number of Variants</label>
          <span className="text-[#00d4aa] font-semibold text-lg">{variantCount}</span>
        </div>
        <input
          type="range"
          min="1"
          max="10"
          value={variantCount}
          onChange={(e) => onVariantCountChange?.(parseInt(e.target.value, 10))}
          className="w-full h-2 bg-white/10 rounded-lg appearance-none cursor-pointer slider"
          style={{
            background: `linear-gradient(to right, #00d4aa 0%, #00d4aa ${((variantCount - 1) / 9) * 100}%, rgba(255, 255, 255, 0.1) ${((variantCount - 1) / 9) * 100}%, rgba(255, 255, 255, 0.1) 100%)`
          }}
        />
        <style>{`
          .slider::-webkit-slider-thumb {
            appearance: none;
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background: #00d4aa;
            cursor: pointer;
            border: 2px solid #00d4aa;
            box-shadow: 0 0 8px rgba(0, 212, 170, 0.4);
          }

          .slider::-moz-range-thumb {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background: #00d4aa;
            cursor: pointer;
            border: 2px solid #00d4aa;
            box-shadow: 0 0 8px rgba(0, 212, 170, 0.4);
          }

          .slider::-webkit-slider-thumb:hover {
            background: #00e5bb;
            box-shadow: 0 0 12px rgba(0, 212, 170, 0.6);
          }

          .slider::-moz-range-thumb:hover {
            background: #00e5bb;
            box-shadow: 0 0 12px rgba(0, 212, 170, 0.6);
          }
        `}</style>
      </div>

      {/* Tier Selection Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {TIERS.map((tier) => {
        const Icon = tier.icon;
        const isSelected = value === tier.id;

        return (
          <button
            key={tier.id}
            type="button"
            onClick={() => onChange(tier.id)}
            className={`p-4 rounded-lg border-2 transition-all text-left ${
              isSelected
                ? 'border-[#00d4aa] bg-[#00d4aa]/10'
                : 'border-white/10 bg-white/5 hover:border-white/20'
            }`}
          >
            <div className="flex items-start gap-3 mb-3">
              <Icon className={`w-6 h-6 flex-shrink-0 ${isSelected ? 'text-[#00d4aa]' : 'text-white/60'}`} />
              <h3 className="font-semibold text-white">{tier.label}</h3>
            </div>
            <div className="space-y-1 text-sm">
              <div className="flex justify-between">
                <span className="text-white/60">Cost:</span>
                <span className="text-green-400 font-medium">${(tier.cost * variantCount).toFixed(3)}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-white/60">Speed:</span>
                <span className="text-blue-400 font-medium">{tier.speed}</span>
              </div>
            </div>
          </button>
        );
      })}
      </div>
    </div>
  );
}

export default QualityTierPicker;
